/**
 * The Nava product lines a record can belong to: Insights, the research product,
 * and Customer Success, the check-in product.
 */
export const PRODUCT_LINES = ['insights', 'customer_success'];
/** Everything created before product lines existed belongs to Insights. */
export const DEFAULT_PRODUCT_LINE = 'insights';
//# sourceMappingURL=ProductLine.js.map